import { render, staticRenderFns } from "./ProcessDesigner.vue?vue&type=template&id=5391b3fc&scoped=true&xmlns%3Av-on=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&xmlns%3Av-bind=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./ProcessDesigner.vue?vue&type=script&lang=js&"
export * from "./ProcessDesigner.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDesigner.vue?vue&type=style&index=0&id=5391b3fc&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5391b3fc",
  null
  
)

export default component.exports